<div *ngIf="cargando && translate.currentLang == 'gb'" class="flex justify-center items-center min-h-screen">
  <div class="flex flex-col items-center">
    <div class="spinner-border animate-spin inline-block w-12 h-12 border-4 border-t-transparent border-azul rounded-full" role="status"></div>
    <p class="mt-4 text-lg text-azul">{{'cargando-entradas' | translate}}</p>
  </div>
</div>
<div *ngIf="!cargando" class="container mx-auto p-5 flex flex-col items-center justify-center">
    <div class="my-5 text-center animate-fade animate-delay-300">
      <h1 class="text-2xl text-azul font-bold">{{'area-entradas' | translate}}</h1>
    </div>
    <!-- Tabla Entradas Aficionado -->
    <table class="text-sm w-full text-black border-2 border-azul animate-fade-down animate-delay-300">
      <thead class="text-white uppercase bg-azul">
        <tr>
          <th scope="col" class="border-r-2 border-white px-6 py-3">{{'num-entrada' | translate}}</th>
          <th scope="col" class="border-r-2 border-white px-6 py-3">{{'id-partido' | translate}}</th>
          <th scope="col" class="border-r-2 border-white px-6 py-3">{{'precio-entrada' | translate}}</th>
          <th scope="col" class="border-r-2 border-white px-6 py-3">{{'zona' | translate}}</th>
          <th scope="col" class="border-r-2 border-azul px-6 py-3">{{'estado' | translate}}</th>
        </tr>
      </thead>
      <tbody class="text-center">
        <tr *ngFor="let entrada of entradas" class="border border-azul">
          <td class="px-6 py-4 border-r border-azul">{{entrada.ID}}</td>
          <td class="px-6 py-4 border-r border-azul cursor-pointer" (click)="consultarPartido(entrada.id_Partido)">{{entrada.id_Partido}} 🔎
          </td>
          <td class="px-6 py-4 border-r border-azul">{{entrada.precio}} €</td>
          <td class="px-6 py-4 border-r border-azul">{{entrada.zona.toUpperCase()}}</td>
          <td class="px-6 py-4 border-r border-azul bg-blue-200" [ngClass]="{
            'bg-green-200': entrada.estado === 'pagada' || entrada.estado === 'paid',
            'bg-red-200': entrada.estado === 'cancelada' || entrada.estado === 'canceled'}">
            {{entrada.estado.toUpperCase()}}
          </td>   
        </tr>
      </tbody>
  </table>
  </div>
  
  
  